import React from 'react';
import styled from 'styled-components';

// Estilos inline para garantir layout correto
const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const MainPrice = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0;
  color: #fafafa;
`;

const PriceText = styled.span`
  font-size: 48px;
  font-weight: 700;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

const PriceSuffix = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #71717a;
  margin-left: 4px;
`;

const SubText = styled.div`
  font-size: 14px;
  color: #a1a1aa;
  text-align: center;

  span {
    color: #fafafa;
    font-weight: 600;
  }
`;

const TagLine = styled.div`
  font-size: 13px;
  color: #71717a;
  margin-top: 4px;
`;

interface PriceDisplayProps {
  isMonthly?: boolean;
  currencySymbol: string;
  price: string;
  billing: string;
  paymentInfo: string;
  installmentPrefix?: string;
  installmentValue?: string;
  installmentSuffix?: string;
  cashLabel?: string;
  cashPrice?: string;
  cashSuffix?: string;
}

const PriceDisplay: React.FC<PriceDisplayProps> = ({
  isMonthly = false,
  currencySymbol,
  price,
  billing,
  paymentInfo,
  installmentPrefix,
  installmentValue,
  installmentSuffix,
  cashLabel,
  cashPrice,
  cashSuffix
}) => {
  if (isMonthly) {
    // Mensal: R$ 197 /mês
    return (
      <PriceWrapper>
        <MainPrice>
          <PriceText>{currencySymbol} {price}</PriceText>
        </MainPrice>
        <TagLine>/{billing}</TagLine>
        <SubText>{paymentInfo}</SubText>
      </PriceWrapper>
    );
  }

  // Trimestral/Anual: 3x R$ 150 | sem juros • ou R$ 400 à vista
  return (
    <PriceWrapper>
      <MainPrice>
        <PriceText>{installmentPrefix} {currencySymbol} {installmentValue}</PriceText>
      </MainPrice>
      <SubText>
        {installmentSuffix} • {cashLabel} <span>{currencySymbol} {cashPrice}</span> {cashSuffix}
      </SubText>
    </PriceWrapper>
  );
};

export default PriceDisplay;
